import { useState } from 'react';

export const useDropdownDelay = (delayMs = 300) => {
  const [isOpen, setIsOpen] = useState(false);
  const [closeTimeout, setCloseTimeout] = useState(null);

  const handleMouseEnter = () => {
    let windowWidth = window.innerWidth;
    if (windowWidth > 992) {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        setCloseTimeout(null);
      }
      setIsOpen(true);
    }
  };

  const handleMouseLeave = () => {
    let windowWidth = window.innerWidth;
    if (windowWidth > 992) {
      const timeout = setTimeout(() => {
        setIsOpen(false);
      }, delayMs);
      setCloseTimeout(timeout);
    }
  };

  const toggle = () => setIsOpen(prevState => !prevState);

  return {
    isOpen,
    toggle,
    handleMouseEnter,
    handleMouseLeave
  };
};
